export const COMPANY_EMAIL =
  import.meta.env.VITE_COMPANY_EMAIL?.trim() || "team@myteengig.com";

export const COMPANY_EMAIL_MAILTO = `mailto:${COMPANY_EMAIL}`;
